module.exports = __webpack_public_path__ + "static/media/cover.feb606e3.jpg";